// extracted by mini-css-extract-plugin
module.exports = {"btnTop":"ScrollToTopButton_btnTop__Ss9TZ","visible":"ScrollToTopButton_visible__3ZgUE","btnTopText":"ScrollToTopButton_btnTopText__QEgvX"};